(function () {
    'use strict';

    angular
        .module('componentVisualGuidelinesControllers')
        .controller('VisualGuidelinesComponentFallbackSrcController', Controller);

    Controller.$inject = ['$scope', 'env', 'esbEmployeeService'];

    function Controller($scope, env, esbEmployeeService) {

        $scope.fallbackCtxt = {};

        var employeeToFound = 'Didier Rano';
        if (_.isUndefined(env.isDev) || env.isDev === false) {
            employeeToFound = 'David Ouellet';
        }

        esbEmployeeService.searchEmployees(employeeToFound)
            .then(function (employees) {
                $scope.fallbackCtxt.Person = employees[0];
            });
    }
})();